import { createContext } from "react";

export const LangUpdateContext = createContext();
